var _style, _path;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgUsersBlue = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 20 16",
    style: {
      enableBackground: "new 0 0 20 16"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#137EBB;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M16.1,8.5c0.9-0.5,1.4-1.5,1.4-2.6c0-1.7-1.4-3.1-3.1-3.1s-3.1,1.4-3.1,3.1c0,1.1,0.6,2,1.4,2.6 c-0.7,0.3-1.4,0.7-1.9,1.3c-0.6-0.6-1.3-1-2.1-1.3c1.4-0.7,2.3-2.1,2.3-3.7c0-2.3-1.9-4.2-4.2-4.2c-2.3,0-4.2,1.9-4.2,4.2 c0,1.6,0.9,3,2.3,3.7C2.5,9.4,0.6,12,0.6,15c0,0.2,0.2,0.4,0.4,0.4h11.8c0.2,0,0.4-0.2,0.4-0.4c0-0.6-0.1-1.2-0.2-1.8h5.8 c0.2,0,0.4-0.2,0.4-0.4C19.2,10.8,17.9,9.1,16.1,8.5z M12.2,5.8c0-1.3,1-2.3,2.3-2.3s2.3,1,2.3,2.3s-1,2.3-2.3,2.3 S12.2,7.1,12.2,5.8z M3.6,4.8c0-1.9,1.5-3.4,3.4-3.4s3.4,1.5,3.4,3.4S8.8,8.1,6.9,8.1S3.6,6.6,3.6,4.8z M1.4,14.6 c0.2-3,2.7-5.7,5.5-5.7c2.3,0,4.4,1.8,5.2,4c0,0,0,0,0,0c0.2,0.5,0.3,1,0.3,1.6H1.4z M12.8,12.4c-0.3-0.8-0.7-1.5-1.3-2.1 c0.7-0.9,1.8-1.4,3-1.4c2,0,3.7,1.5,3.9,3.5H12.8z"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgUsersBlue, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/users-blue.500c5b3e.svg";
export { ForwardRef as ReactComponent };